<div class="table__row" role="row" [ngClass]="{'table__row--last': isLast, 'table__row--alt': isOdd}" [formGroup]="item">
    <div class="table__cell table__cell--align-left" role="cell">
        {{ chargeItm.rentalCategoryName}}
    </div>
    <div class="table__cell" role="cell">
        {{ chargeItm.rentalCategoryCode}}
    </div>
    <div class="table__cell" role="cell">
        {{ chargeItm.state}}
    </div>
    <div class="table__cell" role="cell">
        <span opusAuthorize="Distribution.ViewShippingCharges" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_EntityAdmin']">{{ chargeItm.ground | currency }}</span>
        <input type="number" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/" step="0.01" class="table__cell input--inline" role="cell" id="groundShipping" formControlName="ground" [class.input--readonly]="!isEditing" />
    </div>
    <div class="table__cell" role="cell">
        <span opusAuthorize="Distribution.ViewShippingCharges" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_EntityAdmin']">{{ chargeItm.twoDay | currency }}</span>
        <input type="number" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/" step="0.01" class="table__cell input--inline" role="cell" id="twoDayShipping" formControlName="twoDay" [class.input--readonly]="!isEditing" />
    </div>
    <div class="table__cell" role="cell">
        <span opusAuthorize="Distribution.ViewShippingCharges" opusAuthorizeAction="show" [opusRelationshipManagerRoles]="['aa_OPUS-MAA_EntityAdmin']">{{ chargeItm.overnight | currency }}</span>
        <input type="number" ng-pattern="/^[0-9]+(\.[0-9]{1,2})?$/" step="0.01" class="table__cell input--inline" role="cell" id="overnightShipping" formControlName="overnight" [class.input--readonly]="!isEditing" />
    </div>
</div>
